import img1 from "./Super-Mario-Logo.jpeg"

function Top() {
  return (
    <>
    <h1>Mario Slideshow</h1>
    <div className="logo">
      <img src={img1} alt ="MARIO LOGO" />
      </div>
      </>
  )
}

export default Top;